import React from 'react';

import  maskCamera from './../../assets/mask.png';

declare global {
     interface Window {
          stream:any;
          canvas:any;
     }
}


type MyProps = {
     actionNext?:any
}

type MyState = { 
     facingMode:String
     showButtonSwichCamera:boolean
};
  

const DetectRTC = require('detectrtc');
export class PageTakeFotoForm extends React.Component<MyProps, MyState>{

     constructor(props:any) {
          super(props)

          this.state=DetectRTC.isMobileDevice?{
               facingMode:"user",
               showButtonSwichCamera:true
          }:{
               facingMode:"environment",
               showButtonSwichCamera:true
          }
     }

     initCamera(){
          //"hack" de scopes vars
          let facingMode:any=this.state.facingMode;

          DetectRTC.load(async function() {
               if(DetectRTC.isWebRTCSupported){
                       window.stream && window.stream.getTracks().forEach(( e: { stop: () => any; } ) => e.stop());
                           
                       // https://developer.mozilla.org/en-US/docs/Web/API/MediaTrackConstraints/facingMode
                       let resolution:any=DetectRTC.browser.isChrome && DetectRTC.isMobileDevice
                       ? { audio: !1, video: { width: { ideal: 1920 }, height: { ideal: 1080 }, facingMode: facingMode } }
                       : { audio: !1, video: { width: { min: 720, ideal: 3840, max: 4e3 }, height: { min: 720, ideal: 2160, max: 4e3 }, facingMode: facingMode } }
                         
                       console.log("Resolucion encontrada:",JSON.stringify(resolution));
                   try{
                       let mediaStream=await navigator.mediaDevices.getUserMedia(resolution);
                       window.stream = mediaStream;

                       let video:any=document.getElementById('video')
                       video.srcObject = mediaStream; 

                       window.stream.getVideoTracks()[0].getSettings();

                       console.log("Camara puesta")
                         //Fin de la carga

                   }catch(e){
                       alert("You have to grant permissions to your camera. The app will now be reloaded. Please start again!");
                       window.location.reload(false);
                   }
           
               }else
                   alert("Please use Chrome, Firefox, iOS 11, Android 5 or above, or Safari 11 or above!")
           
             })
     }

     swichCamera = () => {
          if(this.state.facingMode==="environment")
               this.setState({facingMode:"user"});
          else 
               this.setState({facingMode:"environment"});
               
          this.initCamera();
     }

     takeSnapshot= ()=>{
          let video:any=document.getElementById('video');
          let canvas:any=document.getElementById('videocanvas');
          
          //FIXME: se debe regresar el canvas no mapearlo directamente
          canvas.width = video.videoWidth; 
          canvas.height = video.videoHeight;
          canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height) 
          
          
          console.log("Foto tomada");
          console.log("W:",canvas.width,",H:",canvas.height);

          this.props.actionNext()
     }

     render = () =>
     <div className="PageTakeFotoForm">
          <div id="vid_container">
               <video id="video" autoPlay playsInline />
               <div id="video_overlay">
                    <div className="spacer"></div>
                    <img src={maskCamera} className="mask"  alt="mask"/>
                    <div className="spacer"></div>
               </div>
          </div>
     
          <div id="gui_controls">
               {this.state.showButtonSwichCamera?<button id="switchCameraButton" name="switch Camera"   onClick={this.swichCamera}  type="button" ></button>:null}
               <button id="takePhotoButton" name="take Photo" onClick={this.takeSnapshot} type="button"></button>
          </div>
     </div>
}